// /store/modules/LeadGenerator.js
import apiClient from "../../plugins/axios";

export default {
    namespaced: true,
    state: () => ({
        loading: false,
    }),
    mutations: {
        setLoading(state, loading) {
            state.loading = loading;
        },
    },
    actions: {
        async generateLeads({ commit }, payload) {
            commit("setLoading", true);
            try {
                const response = await apiClient.post("/actions/generateLeads", payload);
                console.log(response.data);
            } catch (error) {
                console.error("Failed to generate leads:", error);
            } finally {
                commit("setLoading", false);
            }
        },
        async sendJSONToWebhook({ commit }, payload) {
            commit("setLoading", true);
            try {
                const response = await apiClient.post("/actions/sendJSONToWebhook", payload);
                console.log(response.data);
            } catch (error) {
                console.error("Failed to send JSON to webhook:", error);
            } finally {
                commit("setLoading", false);
            }
        },
    },
};